// import './assets/main_cz.scss'
import './assets/main_sk.scss'

import * as Sentry from "@sentry/vue"
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'

import App from './App.vue'
import { setupI18n } from './i18n.js'

const i18n = setupI18n({
	locale: 'cz',
})
// loadLocaleMessages(i18n, 'cz')

const pinia = createPinia()
const app = createApp(App)

pinia.use(piniaPluginPersistedstate)

Sentry.init({
	app,
	dsn: "https://4aee57bd28f1c531c24f7e0d9954fb5d@o70098.ingest.us.sentry.io/4507298499592192",
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: [/^https:\/\/predplatne\.forbes\.cz/],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})


app.use(pinia)
app.use(i18n)
app.mount('#app')
